/** Normalize YouTube / Facebook URLs for iframe embed */
export function toEmbedVideoUrl(url) {
  if (!url || typeof url !== 'string') return '';
  const u = url.trim();
  if (!u) return '';

  if (u.includes('facebook.com/plugins/video.php')) return u;

  const ytWatch = u.match(/(?:youtube\.com\/watch\?v=|youtu\.be\/)([\w-]+)/i);
  if (ytWatch) return `https://www.youtube.com/embed/${ytWatch[1]}`;

  if (/youtube\.com\/embed\//i.test(u)) return u;

  const fbVideo = u.match(/facebook\.com\/(?:.*\/)?videos\/(\d+)/i);
  if (fbVideo) {
    return `https://www.facebook.com/plugins/video.php?height=314&href=${encodeURIComponent(u)}&show_text=false&width=560`;
  }

  return u;
}

export function isDirectVideoFile(url) {
  if (!url || typeof url !== 'string') return false;
  if (url.includes('/ads/media/')) return true;
  return /\.(mp4|webm|ogg|mov)(\?|$)/i.test(url);
}

/** Full URL for hosted or external video sources */
export function resolveAdVideoSrc(videoUrl, apiBase = '') {
  if (!videoUrl) return '';
  if (videoUrl.startsWith('http://') || videoUrl.startsWith('https://')) return videoUrl;
  if (videoUrl.startsWith('/')) return `${apiBase}${videoUrl}`;
  return videoUrl;
}
